<!-- Edit Expense Modal -->
<div class="modal fade" id="editExpenseModal" msEscClose
    (escPressed)="onCancel()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="editExpenseModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <div class="fs-5 border-0 p-4 pb-0">
                <div class="fw-semibold" id="editExpenseModalLabel">Edit Expense</div>
            </div>

            <div class="modal-body px-4">

                <!-- Immutable context: changing any of these needs a void and a re-entry -->
                @if (expense(); as editedExpense) {
                    <div class="row g-2 mb-4">
                        <div class="col-4">
                            <div class="fw-semibold small">Amount Paid</div>
                            <div class="text-muted">{{ editedExpense.amount | CurrencyDisplay: editedExpense.currency | noValue }}</div>
                        </div>
                        <div class="col-4">
                            <div class="fw-semibold small">Date Paid</div>
                            <div class="text-muted">{{ editedExpense.datePaid | orgDate: 'shortDate' | noValue }}</div>
                        </div>
                        <div class="col-4">
                            <div class="fw-semibold small">Expense Type</div>
                            <div class="text-muted">{{ editedExpense.expenseAccount.name | noValue }}</div>
                        </div>
                    </div>
                }

                <form [formGroup]="editForm" (keydown.enter)="$event.preventDefault()">

                    <!-- Payee Name -->
                    <ms-input-label [isRequired]="isFieldRequired(editForm, 'vendorName')" [labelText]="'Payee Name'" />
                    <input
                        type="text"
                        id="editVendorName"
                        formControlName="vendorName"
                        [required]="isFieldRequired(editForm, 'vendorName')"
                        maxlength="250"
                        class="form-control"
                        [class.is-invalid]="editForm.get('vendorName')?.invalid && editForm.get('vendorName')?.touched"
                        [class.is-valid]="editForm.get('vendorName')?.valid && editForm.get('vendorName')?.touched && editForm.get('vendorName')?.value !== ''" />
                    @if (editForm.get('vendorName')?.invalid && editForm.get('vendorName')?.touched) {
                        <div class="error-messages">
                            @if (editForm.get('vendorName')?.errors?.['required']) {
                                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpensePayeeNameRequired }}</p>
                            }
                            @if (editForm.get('vendorName')?.errors?.['minlength']) {
                                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpensePayeeNameMinLength }}</p>
                            }
                            @if (editForm.get('vendorName')?.errors?.['maxlength']) {
                                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpensePayeeNameMaxLength }}</p>
                            }
                        </div>
                    }

                    <!-- Check/Reference # -->
                    <ms-input-label [labelText]="'Check/Reference #'" class="mt-3" />
                    <input
                        type="text"
                        id="editReferenceNumber"
                        formControlName="referenceNumber"
                        maxlength="30"
                        class="form-control"
                        [class.is-invalid]="editForm.get('referenceNumber')?.invalid && editForm.get('referenceNumber')?.touched"
                        [class.is-valid]="editForm.get('referenceNumber')?.valid && editForm.get('referenceNumber')?.touched && editForm.get('referenceNumber')?.value !== ''" />
                    @if (editForm.get('referenceNumber')?.invalid && editForm.get('referenceNumber')?.touched) {
                        <div class="error-messages">
                            @if (editForm.get('referenceNumber')?.errors?.['maxlength']) {
                                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpenseReferenceNumberMaxLength }}</p>
                            }
                            @if (editForm.get('referenceNumber')?.errors?.['pattern']) {
                                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpenseReferenceNumberPattern }}</p>
                            }
                        </div>
                    }

                    <!-- Notes -->
                    <ms-input-label [labelText]="'Notes'" class="mt-3" />
                    <textarea
                        id="editDescription"
                        formControlName="description"
                        maxlength="500"
                        rows="3"
                        class="form-control"
                        [class.is-valid]="editForm.get('description')?.valid && editForm.get('description')?.touched && editForm.get('description')?.value !== ''"></textarea>
                    @if (editForm.get('description')?.errors?.['maxlength'] && editForm.get('description')?.touched) {
                        <div class="error-messages">
                            <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpenseDescriptionMaxLength }}</p>
                        </div>
                    }
                </form>
            </div>

            <div class="modal-footer border-0 d-flex justify-content-center pb-4">
                <button type="button" class="btn btn-ms-secondary" (click)="onCancel()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" (click)="onSubmit()">
                    @if (isSubmitting) {
                        <div class="spinner-border text-light spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    } @else {
                        Save
                    }
                </button>
            </div>

        </div>
    </div>
</div>

<!-- Confirmation Modal -->
<ms-confirmation-modal #editExpenseConfirmationRef modalId="editExpenseConfirmationModal"
    confirmButtonText="Save" cancelButtonText="Cancel"
    (confirmed)="confirmSubmit($event)"
    (cancelled)="confirmationCancelled()" />

<!-- Info Modal -->
<ms-info-modal #editExpenseInfoRef modalId="editExpenseInfoModal"
    (onConfirm)="infoModalConfirmed()" />

<!-- Esc Confirmation Modal -->
<ms-confirmation-modal #editExpenseEscConfirmationRef modalId="editExpenseEscConfirmationModal"
    confirmButtonText="Leave" cancelButtonText="Stay"
    (confirmed)="escConfirmed()"
    (cancelled)="escCancelled()" />
